"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var currencies = {
    EUR: "€",
    USD: "$",
    GBP: "£",
    CHF: "CHF",
};
var FormatPrice = function (value, currency) {
    if (currency === void 0) { currency = "EUR"; }
    if (!value) {
        return "-";
    }
    return [
        (value / 100).toFixed(2),
        currencies[currency],
    ].join("");
};
exports.FormatPrice = FormatPrice;
//# sourceMappingURL=format-price.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/helpers/format-price.js
// module id = 881
// module chunks = 3